/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { RoleType } from './RoleType';
import {
    RoleTypeFromJSON,
    RoleTypeFromJSONTyped,
    RoleTypeToJSON,
} from './RoleType';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { AppPermissionsEnum } from './AppPermissionsEnum';
import {
    AppPermissionsEnumFromJSON,
    AppPermissionsEnumFromJSONTyped,
    AppPermissionsEnumToJSON,
} from './AppPermissionsEnum';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { RoleStateOfUse } from './RoleStateOfUse';
import {
    RoleStateOfUseFromJSON,
    RoleStateOfUseFromJSONTyped,
    RoleStateOfUseToJSON,
} from './RoleStateOfUse';
import type { HistoryDtoUser } from './HistoryDtoUser';
import {
    HistoryDtoUserFromJSON,
    HistoryDtoUserFromJSONTyped,
    HistoryDtoUserToJSON,
} from './HistoryDtoUser';

/**
 * 
 * @export
 * @interface RoleDto
 */
export interface RoleDto {
    /**
     * 
     * @type {number}
     * @memberof RoleDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof RoleDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RoleDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RoleDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {RoleType}
     * @memberof RoleDto
     */
    type?: RoleType;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<AppPermissionsEnum>}
     * @memberof RoleDto
     */
    grantedPermissions?: Array<AppPermissionsEnum> | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    permissionsUpdated?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RoleDto
     */
    assignedUsersCount?: number;
    /**
     * 
     * @type {RoleStateOfUse}
     * @memberof RoleDto
     */
    state?: RoleStateOfUse;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    wasAssigned?: boolean;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof RoleDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {number}
     * @memberof RoleDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RoleDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof RoleDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof RoleDto
     */
    creatorUser?: HistoryDtoUser | null;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof RoleDto
     */
    lastModifierUser?: HistoryDtoUser | null;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof RoleDto
     */
    possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof RoleDto
     */
    editingUser?: HistoryDtoUser | null;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    $type?: RoleDtoTypeEnum;
}


/**
 * @export
 */
export const RoleDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedAuthorizationRolesDtoRoleDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Authorization.Roles.Dto.RoleDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type RoleDtoTypeEnum = typeof RoleDtoTypeEnum[keyof typeof RoleDtoTypeEnum];



/**
 * Check if a given object implements the RoleDto interface.
 */
export function instanceOfRoleDto(value?: unknown): value is RoleDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(RoleDtoTypeEnum)[0];
}

export function RoleDtoFromJSON(json: any): RoleDto {
    return RoleDtoFromJSONTyped(json, false);
}

export function RoleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'isDeleted': json['isDeleted'] == null ? undefined : json['isDeleted'],
        'deleterUserId': json['deleterUserId'] == null ? undefined : json['deleterUserId'],
        'deletionTime': json['deletionTime'] == null ? undefined : json['deletionTime'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'type': json['type'] == null ? undefined : RoleTypeFromJSON(json['type']),
        'name': json['name'] == null ? undefined : json['name'],
        'displayName': json['displayName'],
        'description': json['description'] == null ? undefined : json['description'],
        'grantedPermissions': json['grantedPermissions'] == null ? undefined : ((json['grantedPermissions'] as Array<any>).map(AppPermissionsEnumFromJSON)),
        'permissionsUpdated': json['permissionsUpdated'] == null ? undefined : json['permissionsUpdated'],
        'assignedUsersCount': json['assignedUsersCount'] == null ? undefined : json['assignedUsersCount'],
        'state': json['state'] == null ? undefined : RoleStateOfUseFromJSON(json['state']),
        'wasAssigned': json['wasAssigned'] == null ? undefined : json['wasAssigned'],
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'commentAttachmentsCount': json['commentAttachmentsCount'] == null ? undefined : json['commentAttachmentsCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'creatorUser': json['creatorUser'] == null ? undefined : HistoryDtoUserFromJSON(json['creatorUser']),
        'lastModifierUser': json['lastModifierUser'] == null ? undefined : HistoryDtoUserFromJSON(json['lastModifierUser']),
        'possibleActions': json['possibleActions'] == null ? undefined : ((json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'editingUser': json['editingUser'] == null ? undefined : HistoryDtoUserFromJSON(json['editingUser']),
        'editingTime': json['editingTime'] == null ? undefined : json['editingTime'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function RoleDtoToJSON(value?: Omit<RoleDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'|'isDeleted'|'deleterUserId'|'deletionTime'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'iuid': value['iuid'],
        'type': RoleTypeToJSON(value['type']),
        'name': value['name'],
        'displayName': value['displayName'],
        'description': value['description'],
        'grantedPermissions': value['grantedPermissions'] == null ? undefined : ((value['grantedPermissions'] as Array<any>).map(AppPermissionsEnumToJSON)),
        'permissionsUpdated': value['permissionsUpdated'],
        'assignedUsersCount': value['assignedUsersCount'],
        'state': RoleStateOfUseToJSON(value['state']),
        'wasAssigned': value['wasAssigned'],
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(PtwCommentDtoToJSON)),
        'commentCount': value['commentCount'],
        'commentAttachmentsCount': value['commentAttachmentsCount'],
        'lastComment': value['lastComment'],
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isAvailable': value['isAvailable'],
        'creatorUser': HistoryDtoUserToJSON(value['creatorUser']),
        'lastModifierUser': HistoryDtoUserToJSON(value['lastModifierUser']),
        'possibleActions': value['possibleActions'] == null ? undefined : ((value['possibleActions'] as Array<any>).map(PossibleActionDtoToJSON)),
        'editingUser': HistoryDtoUserToJSON(value['editingUser']),
        'editingTime': value['editingTime'],
        '$type': value['$type'],
    });
}

